export enum StepMode {
    plus = 1,
    nothing = 0,
    minus = -1
}
